import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { track } from '../lib/contact';
import { useSite } from '../content/SiteContext';

const NAV = [
  { to: '/services', label: 'Services' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/car-wash-app', label: 'App' },
  { to: '/membership', label: 'Membership' },
  { to: '/corporate-fleet-car-wash', label: 'Corporate' },
  { to: '/locations', label: 'Locations' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' }
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const { NAV_HEADER, BUSINESS } = useSite();
  const nav = NAV_HEADER.length ? NAV_HEADER.slice().sort((a, b) => (a.order || 0) - (b.order || 0)).map((n) => ({ to: n.href, label: n.label })) : NAV;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <header className={`site-header${scrolled ? ' is-scrolled' : ''}${open ? ' is-open' : ''}`}>
      <a href="#main" className="skip-link">Skip to content</a>
      <div className="container site-header__inner">
        <Link to="/" className="brand" aria-label="Quick Way home">
          <img src="/img/mark-96.png" alt="" width="40" height="40" />
          <span>Quick Way</span>
        </Link>
        <nav id="primary-nav" className="site-nav" aria-label="Main">
          <ul>
            {nav.map((item) => (
              <li key={item.to}><NavLink to={item.to}>{item.label}</NavLink></li>
            ))}
          </ul>
          <a href={BUSINESS.playStore} target="_blank" rel="noopener noreferrer" className="btn btn-primary site-nav__mobile-cta"
            onClick={() => track('app_store_click', { store: 'google_play', source: 'header' })}>Get the app</a>
        </nav>
        <div className="site-header__actions">
          <a href={BUSINESS.playStore} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm"
            onClick={() => track('app_store_click', { store: 'google_play', source: 'header' })}>Get the app</a>
          <button type="button" className="menu-toggle" aria-expanded={open} aria-controls="primary-nav"
            aria-label={open ? 'Close menu' : 'Open menu'} onClick={() => setOpen((v) => !v)}>
            <span /><span /><span />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
